/*
 *   This content is licensed according to the W3C Software License at
 *   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 */

'use strict'

/*
 *   @constructorDisclosureButton
 *
 *
 */
class DisclosureButton {
    constructor(buttonNode) {
        this.buttonNode = buttonNode
        this.controlledNode = false
        this.disclosureType = undefined

        const id = this.buttonNode.getAttribute('aria-controls')

        if (id) {
            this.controlledNode = document.getElementById(id)
        }

        this.disclosureType = this.buttonNode.getAttribute('data-disclosure-type')

        if (this.disclosureType === 'verify-height') {
            verifyHeight(this.controlledNode, buttonNode)
        }

        this.buttonNode.addEventListener('click', this.onClick.bind(this))
    }

    showContent() {
        if (this.controlledNode) {
            this.controlledNode.classList.add('active')
        }
    }

    hideContent() {
        if (this.controlledNode) {
            this.controlledNode.classList.remove('active')
        }
    }

    toggleExpand() {
        if (this.buttonNode.getAttribute('aria-expanded') === 'true') {
            this.buttonNode.setAttribute('aria-expanded', 'false')
            this.hideContent()
        } else {
            this.buttonNode.setAttribute('aria-expanded', 'true')
            this.showContent()
        }
    }

    showTab() {
        const allTabs = document.querySelectorAll(`[data-parent-tab-id="${this.buttonNode.getAttribute('data-parent-tab-id')}"]`)
        allTabs.forEach((tab) => {
            const tabNode = document.getElementById(tab.getAttribute('aria-controls'))
            if (tabNode) {
                tabNode.classList.remove('active')
            }
            tab.setAttribute('aria-expanded', 'false')
            tab.classList.remove('active')
        })

        this.buttonNode.setAttribute('aria-expanded', 'true')
        this.buttonNode.classList.add('active')
        this.showContent()
    }

    /* EVENT HANDLERS */

    onClick() {
        if (this.buttonNode.hasAttribute('data-parent-tab-id')) {
            this.showTab()
        } else {
            this.toggleExpand()
        }
    }
}

/* Initialize Hide/Show Buttons */
function initDisclosure() {
    const buttons = document.querySelectorAll('button[aria-expanded][aria-controls]')

    buttons.forEach((button) => {
        new DisclosureButton(button)
    })
}

document.addEventListener('livewire:init', () => {
    Livewire.on('step-changed', (el, component) => {
        setTimeout(() => {
            initDisclosure()
        }, 200)
    })
})

document.addEventListener('livewire:navigated', (e) => {
    initDisclosure()
})

function verifyHeight(controlledNode, buttonNode) {
    if (controlledNode.scrollHeight <= controlledNode.offsetHeight) {
        buttonNode.style.display = 'none'
    }
}

function verifyInitialCheck(checkboxes) {
    return Array.from(checkboxes).some((checkbox) => checkbox.checked)
}
